"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function accessor(accessor, handler) {
    if (handler === void 0) { handler = null; }
    var get = new Function("return this." + accessor);
    var set = new Function('value', "this." + accessor + " = value");
    if (handler) {
        set = eval("(function smartSetter(value) {\n      const prev = this." + accessor + ";\n      this." + accessor + " = value;\n      handler(this, prev, value);\n    })");
    }
    return { get: get, set: set };
}
exports.default = accessor;
